module.exports = "/images/icon_32_price.png?75db0a6b808897649c826077a178ae35";